import { PaymentFormFieldNames } from "@common/feature/payment/types/form";

export const PAYMENT_FORM_RULES = {
  [PaymentFormFieldNames.InvoiceSum]: [{ required: true, message: 'Пожалуйста, введите сумму счета' }],
};